import React, { useEffect, useRef } from 'react';

function About() {
    const cardsRef = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, observerOptions);

        cardsRef.current.forEach(card => {
            if (card) {
                card.style.opacity = '0';
                card.style.transform = 'translateY(30px)';
                card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
                observer.observe(card);
            }
        });

        return () => observer.disconnect();
    }, []);

    return (
        <section id="about" className="section about-section">
            <div className="container">
                <div className="section-header">
                    <span className="section-tag">ABOUT US</span>
                    <h2 className="section-title">은혜테크를 소개합니다</h2>
                    <p className="section-description">
                        은혜테크는 PCB 개발 및 양산 전문 기업으로,<br />
                        고객의 성공을 위한 최고의 기술 파트너입니다
                    </p>
                </div>
                
                <div className="about-grid">
                    <div className="about-card" ref={el => cardsRef.current[0] = el}>
                        <div className="about-icon">
                            <i className="fas fa-microchip"></i>
                        </div>
                        <h3>전문성</h3>
                        <p>수년간의 PCB 개발 및 양산 경험을 바탕으로 최고 품질의 제품을 제공합니다</p>
                    </div>
                    
                    <div className="about-card" ref={el => cardsRef.current[1] = el}>
                        <div className="about-icon">
                            <i className="fas fa-rocket"></i>
                        </div>
                        <h3>신속성</h3>
                        <p>빠른 개발 프로세스와 효율적인 양산 체계로 납기를 준수합니다</p>
                    </div>
                    
                    <div className="about-card" ref={el => cardsRef.current[2] = el}>
                        <div className="about-icon">
                            <i className="fas fa-shield-alt"></i>
                        </div>
                        <h3>신뢰성</h3>
                        <p>철저한 품질 관리와 검증 프로세스를 통해 안정적인 제품을 보장합니다</p>
                    </div>
                    
                    <div className="about-card" ref={el => cardsRef.current[3] = el}>
                        <div className="about-icon">
                            <i className="fas fa-handshake"></i>
                        </div>
                        <h3>파트너십</h3>
                        <p>협력사 IF와의 시너지로 하드웨어와 소프트웨어 통합 솔루션을 제공합니다</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;
